import {
  DEFAULT_ACTION,
  LOGIN,
  EMAIL_CHANGE_OTP_REQUEST,
  EMAIL_CHANGE_OTP_VERIFY,
  EMAIL_CHANGE_OTP_RESEND
} from '../action-types';
import {
  UPDATE_NOTIFICATION,
  SHOW_LOADING,
  UPDATE_HEADER_DATA,
  UPDATE_CANDIDATE_FILTERS,
  CANDIDATE_PROFILE,
  CANDIDATE_PROFILE_ERROR
} from '../mutations';
import httpService from '../../network/http-service';
import { handleError } from '../global/actions';
import { API_ENDPOINT } from '../api-action';
import { setCookie } from '../../utils/cookie-service';
import { withJoobleUtm } from '../../utils/joobleTracking';
import { NOTIFICATION_MESSAGES } from '../constants';

export function getDashboard() {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.get({ action: API_ENDPOINT.dashboard });
      return response.data?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function getHeaderCount() {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.get({ action: API_ENDPOINT.headerCount });
      dispatch({ type: UPDATE_HEADER_DATA, payload: response.data });
      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function searchJob(payload, loader = true) {
  return async function (dispatch) {
    if (loader) {
      dispatch({ type: SHOW_LOADING, payload: true });
    }
    try {
      const response = await httpService.get({ action: API_ENDPOINT.searchJob, query: payload });
      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function appliedJob(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.get({ action: API_ENDPOINT.appliedJob, query: payload });
      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function views(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    dispatch({ type: UPDATE_CANDIDATE_FILTERS, payload: payload });
    try {
      const response = await httpService.get({
        action: API_ENDPOINT.employerViewed,
        query: payload
      });
      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function savedJobs(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.get({ action: API_ENDPOINT.savedJob, query: payload });
      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function viewJob(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.get({ action: API_ENDPOINT.viewJob, query: payload });
      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function getChatList(isDisplayLoader) {
  return async function (dispatch) {
    if (isDisplayLoader) dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.get({ action: API_ENDPOINT.fetchChatList });
      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function getChat(query) {
  return async function (dispatch) {
    try {
      const response = await httpService.get({ action: API_ENDPOINT.fetchChat, query: query });
      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    }
  };
}

export function sendChatMessage(payload) {
  return async function (dispatch) {
    try {
      const response = await httpService.put({
        action: API_ENDPOINT.sendChatMessage,
        data: payload
      });
      if (response?.data.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });

        return;
      }

      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    }
  };
}

export function changePassword(payload) {
  return async function (dispatch) {
    try {
      dispatch({ type: SHOW_LOADING, payload: true });
      const response = await httpService.post({
        action: API_ENDPOINT.changePassword,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error' }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success' }
      });

      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function fetchRecruiter() {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.get({ action: API_ENDPOINT.fetchRecruiter });
      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function blockRecruiter(payload) {
  return async function (dispatch) {
    try {
      dispatch({ type: SHOW_LOADING, payload: true });
      const response = await httpService.post({
        action: API_ENDPOINT.blockRecruiter,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: response.data.msg }
      });

      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function unBlockRecruiter(payload) {
  return async function (dispatch) {
    try {
      dispatch({ type: SHOW_LOADING, payload: true });
      const response = await httpService.delete({
        action: API_ENDPOINT.unBlockRecruiter,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: response.data.msg }
      });

      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function fetchSubscription() {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.get({ action: API_ENDPOINT.fetchSubscription });
      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function updateSubscription(payload) {
  return async function (dispatch) {
    try {
      dispatch({ type: SHOW_LOADING, payload: true });
      const response = await httpService.put({
        action: API_ENDPOINT.updateSubscription,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }
      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function fetchSubscription2() {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.get({ action: API_ENDPOINT.fetchSubscription2 });
      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function updateSubscription2(payload) {
  return async function (dispatch) {
    try {
      dispatch({ type: SHOW_LOADING, payload: true });
      const response = await httpService.put({
        action: API_ENDPOINT.updateSubscription2,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: response.data.msg }
      });

      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

// VTS-562: module-level guards for the profile fetch.
//  - inFlightProfileRequest coalesces CONCURRENT identical calls into one
//    network request (covers the SPA / in-app path).
//  - lastProfileFetchAt is a short-lived FRESHNESS timestamp that also
//    short-circuits a SEQUENTIAL double-fetch on hard reload / bookmark /
//    refresh, where App.js's auth-effect fetch resolves (clearing the
//    in-flight guard) ~one backend round-trip BEFORE profile.js's mount
//    fetch is dispatched. Within PROFILE_FRESHNESS_MS of a successful load,
//    if the profile is already in the store, the second call resolves from
//    the store instead of firing a duplicate request.
// Both are reset on logout / user change (resetProfileCache) so Candidate B
// never short-circuits to Candidate A's cached profile.
let inFlightProfileRequest = null;
let lastProfileFetchAt = 0;
const PROFILE_FRESHNESS_MS = 2500;

// Reset the profile fetch guards. Called on logout / user change so a
// different user never reads the prior user's cached/fresh profile.
export function resetProfileCache() {
  inFlightProfileRequest = null;
  lastProfileFetchAt = 0;
}

export function fetchProfile(options = {}) {
  const force = options?.force === true;
  return async function (dispatch, getState) {
    // Mutation path (force=true) always fetches fresh — server recomputes
    // profilepercent / updated_at, so it must bypass the freshness window.
    if (!force) {
      // Coalesce concurrent callers onto the single in-flight request.
      if (inFlightProfileRequest) {
        return inFlightProfileRequest;
      }
      // Freshness short-circuit: a recent successful load + an in-store
      // profile means the second sequential call (hard-reload path) resolves
      // from the store with no network call.
      const existingProfile = getState()?.candidate?.profile;
      const age = Date.now() - lastProfileFetchAt;
      if (existingProfile && lastProfileFetchAt > 0 && age < PROFILE_FRESHNESS_MS) {
        return existingProfile;
      }
    } else if (inFlightProfileRequest) {
      // A forced refetch must still fetch fresh, but if a request is already
      // in flight, join it rather than firing a parallel duplicate.
      return inFlightProfileRequest;
    }

    dispatch({ type: SHOW_LOADING, payload: true });

    inFlightProfileRequest = (async () => {
      try {
        const response = await httpService.get({ action: API_ENDPOINT.fetchProfile });
        dispatch({ type: CANDIDATE_PROFILE, payload: response.data });
        // Clear any prior fetch error on a successful load.
        dispatch({ type: CANDIDATE_PROFILE_ERROR, payload: null });
        lastProfileFetchAt = Date.now();
        return response.data;
      } catch (err) {
        if (err.statusCode === 409) throw err;
        // VTS-562 (TS-030/TS-031): graceful API failure / slow API handling.
        // Surface the error to the profile reducer so the page can render a
        // fallback instead of crashing, and still route through the shared
        // error handler for auth/session flows.
        dispatch({ type: CANDIDATE_PROFILE_ERROR, payload: err?.message || 'PROFILE_FETCH_FAILED' });
        dispatch(handleError(LOGIN, err));
        return undefined;
      } finally {
        dispatch({ type: SHOW_LOADING, payload: false });
        inFlightProfileRequest = null;
      }
    })();

    return inFlightProfileRequest;
  };
}

export function getJobAlert(id) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.get({ action: API_ENDPOINT.jobAlert, segment: id });
      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function saveJobAlert(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.post({
        action: API_ENDPOINT.jobAlert,
        data: payload,
        segment: payload.id
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: response.data.msg }
      });

      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function deleteJobAlert(id) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.delete({ action: API_ENDPOINT.jobAlert, segment: id });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: response.data.msg }
      });

      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function updateSkill(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.put({ action: API_ENDPOINT.updateSkill, data: payload });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: {
          variant: 'success',
          message: `Skill has been ${payload?.id ? 'updated' : 'added'} successfully`
        }
      });

      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function updateSkills2(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const isDeleted = payload.delete;
      delete payload.delete;
      const response = await httpService.put({ action: API_ENDPOINT.updateSkills2, data: payload });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: {
          variant: 'success',
          message: isDeleted
            ? 'Skill has been deleted successfully'
            : 'Skill has been updated successfully'
        }
      });

      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function updateWorkExp(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.post({
        action: API_ENDPOINT.updateWorkExp,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }
      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function updateMoreWorkExp(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.put({
        action: API_ENDPOINT.updateMoreWorkExp,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }
      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: {
          variant: 'success',
          message: `Work Experience has been ${payload?.work_id ? 'updated' : 'added'} successfully`
        }
      });
      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function updateEducation(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.put({
        action: API_ENDPOINT.updateEducation,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: {
          variant: 'success',
          message: `Education has been ${payload?.id ? 'updated' : 'added'} successfully`
        }
      });

      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function updateCertification(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.put({
        action: API_ENDPOINT.updateCertification,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: {
          variant: 'success',
          message: `Certificate has been ${payload?.id ? 'updated' : 'added'} successfully`
        }
      });

      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function updateProject(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.put({ action: API_ENDPOINT.updateProject, data: payload });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: 'Project has been updated successfully' }
      });

      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function updateCompensation(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.put({
        action: API_ENDPOINT.updateCompensation,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: 'Compensation has been updated successfully' }
      });

      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function updateJobPreference(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.put({
        action: API_ENDPOINT.updateCompensation,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: 'Job Preference has been updated successfully' }
      });

      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function updateEmail(payload) {
  return async function (dispatch) {
    try {
      dispatch({ type: SHOW_LOADING, payload: true });
      const response = await httpService.post({ action: API_ENDPOINT.updateEmail, data: payload });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error' }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success' }
      });

      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function updateSocialMedia(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.put({
        action: API_ENDPOINT.updateSocialMedia,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: 'Social Media has been updated successfully' }
      });

      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function updateReference(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.put({
        action: API_ENDPOINT.updateReference,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: 'Reference has been updated successfully' }
      });

      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function updateCurrentLocation(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.put({
        action: API_ENDPOINT.updateCurrentLocation,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: 'Location has been updated successfully' }
      });

      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function updatePersonalInformation(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.put({
        action: API_ENDPOINT.updatePersonalInformation,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: {
          variant: 'success',
          message: 'Personal Information has been updated successfully'
        }
      });
      if ('jwt_token' in response?.data) {
        setCookie('veriipro-chat-token', response.data.jwt_token);
      }
      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function deleteSkill(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.delete({
        action: API_ENDPOINT.deleteSkill,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: 'Skill has been deleted successfully' }
      });

      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function deleteWorkExp(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.delete({
        action: API_ENDPOINT.deleteMoreWorkExp,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: 'Work Experience has been deleted successfully' }
      });

      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function deleteEducation(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.delete({
        action: API_ENDPOINT.deleteEducation,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: 'Education has been deleted successfully' }
      });

      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function deleteCertification(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.delete({
        action: API_ENDPOINT.deleteCertification,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: 'Certificate has been deleted successfully' }
      });

      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function deleteProject(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.delete({
        action: API_ENDPOINT.deleteProject,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: 'Project has been deleted successfully' }
      });

      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function likeJob(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.put({ action: API_ENDPOINT.likeJob, data: payload });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: `Job has been ${payload.action} successfully` }
      });

      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function saveJob(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.put({ action: API_ENDPOINT.saveJob, data: payload });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: {
          variant: 'success',
          message: `Job has been ${payload.action === 'add' ? 'saved' : 'unsaved'} successfully`
        }
      });
      dispatch(getHeaderCount());
      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function updateProfileActivation(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.post({
        action: API_ENDPOINT.profileActivation,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: response.data.msg }
      });

      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function fetchProfileStatus() {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.get({ action: API_ENDPOINT.fetchProfileStatus });
      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(LOGIN, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function updateVideo(payload) {
  return async function (dispatch) {
    try {
      const response = await httpService.post({ action: API_ENDPOINT.updateVideo, data: payload });
      if (response?.data.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });

        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: response.data.msg }
      });

      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    }
  };
}

export function uploadProfilePic(payload) {
  return async function (dispatch) {
    try {
      dispatch({ type: SHOW_LOADING, payload: true });
      const response = await httpService.post({
        action: API_ENDPOINT.updateProfilePic,
        formData: payload
      });
      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}
export function deleteProfilePic() {
  return async function (dispatch) {
    try {
      dispatch({ type: SHOW_LOADING, payload: true });
      const response = await httpService.post({ action: API_ENDPOINT.deleteProfilePic });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: response.data.msg }
      });

      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function applyJob(payload, loader = true) {
  return async function (dispatch) {
    try {
      if (loader) {
        dispatch({ type: SHOW_LOADING, payload: true });
      }
      const response = await httpService.post({ action: API_ENDPOINT.applyJob, data: withJoobleUtm(payload) });
      if (response?.data.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });

        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: response.data.msg }
      });
      dispatch(getHeaderCount());
      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function fetchJobComment(payload) {
  return async function (dispatch) {
    try {
      dispatch({ type: SHOW_LOADING, payload: true });
      const response = await httpService.put({
        action: API_ENDPOINT.fetchJobComment,
        data: payload
      });
      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function postJobComment(payload) {
  return async function (dispatch) {
    try {
      dispatch({ type: SHOW_LOADING, payload: true });
      const response = await httpService.put({ action: API_ENDPOINT.jobComment, data: payload });
      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function deleteVideo() {
  return async function (dispatch) {
    try {
      dispatch({ type: SHOW_LOADING, payload: true });
      const response = await httpService.delete({ action: API_ENDPOINT.deleteVideo });
      if (response?.data.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });

        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: response.data.msg }
      });

      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function applyNoLogin(payload) {
  return async function (dispatch) {
    try {
      dispatch({ type: SHOW_LOADING, payload: true });
      const response = await httpService.post({
        action: API_ENDPOINT.applyNoLogin,
        formData: withJoobleUtm(payload)
      });
      if (response?.data.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });

        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: response.data.msg }
      });

      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function updateResumeAndApply(payload) {
  return async function (dispatch) {
    try {
      dispatch({ type: SHOW_LOADING, payload: true });
      const response = await httpService.post({
        action: API_ENDPOINT.updateResumeAndApply,
        formData: withJoobleUtm(payload)
      });
      if (response?.data.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });

        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: response.data.msg }
      });

      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function skipSignupOTPVerify(payload) {
  return async function (dispatch) {
    try {
      dispatch({ type: SHOW_LOADING, payload: true });
      const response = await httpService.post({
        action: API_ENDPOINT.skipsignupotpverify,
        data: payload
      });
      if (response?.data.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });

        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: response.data.msg }
      });

      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function reSendSignupOTP(payload) {
  return async function (dispatch, state) {
    try {
      dispatch({ type: SHOW_LOADING, payload: true });
      const response = await httpService.post({
        action: API_ENDPOINT.reSendSignupOTP,
        data: payload
      });
      if (response?.data.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });

        return;
      }

      const email = state().auth.currentUser.email;
      const message = `We've sent you the OTP at ${email}, please check your Mail.`;
      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message }
      });

      return { ...response?.data, message };
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function signupOTPVerify(payload) {
  return async function (dispatch) {
    try {
      dispatch({ type: SHOW_LOADING, payload: true });
      const response = await httpService.post({
        action: API_ENDPOINT.signupOTPVerify,
        data: payload
      });
      if (response?.data.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });

        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: response.data.msg }
      });

      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function deleteProfile(payload) {
  return async function (dispatch) {
    try {
      dispatch({ type: SHOW_LOADING, payload: true });
      const response = await httpService.post({
        action: API_ENDPOINT.deleteProfile,
        data: payload
      });
      if (response?.data.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });

        return;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: { variant: 'success', message: response.data.msg }
      });

      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export async function getResumeBase64(payload) {
  try {
    const response = await httpService.post({
      action: API_ENDPOINT.resumeBase64,
      data: payload
    });
    return response.data;
  } catch (err) {
    return err;
  }
}

export function markAsReadMSG(payload) {
  return async function (dispatch) {
    try {
      const response = await httpService.post({
        action: API_ENDPOINT.markAsReadMSG,
        data: payload
      });
      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function parseresume() {
  return async function (dispatch) {
    try {
      const response = await httpService.get({ action: API_ENDPOINT.resumeParsing });
      return response.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(DEFAULT_ACTION, err));
    }
  };
}

export function updateHeaderCount(payload) {
  return async function (dispatch) {
    dispatch({ type: UPDATE_HEADER_DATA, payload: payload });
  };
}

export function emailChangeOtpRequest(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.post({
        action: API_ENDPOINT.emailChangeOtpRequest,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return response?.data;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: NOTIFICATION_MESSAGES[EMAIL_CHANGE_OTP_REQUEST].success
      });
      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(EMAIL_CHANGE_OTP_REQUEST, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function emailChangeOtpVerify(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.post({
        action: API_ENDPOINT.emailChangeOtpVerify,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return response?.data;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: NOTIFICATION_MESSAGES[EMAIL_CHANGE_OTP_VERIFY].success
      });
      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(EMAIL_CHANGE_OTP_VERIFY, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}

export function emailChangeOtpResend(payload) {
  return async function (dispatch) {
    dispatch({ type: SHOW_LOADING, payload: true });
    try {
      const response = await httpService.post({
        action: API_ENDPOINT.emailChangeOtpResend,
        data: payload
      });
      if (response?.data?.error) {
        dispatch({
          type: UPDATE_NOTIFICATION,
          payload: { variant: 'error', message: response.data.msg }
        });
        return response?.data;
      }

      dispatch({
        type: UPDATE_NOTIFICATION,
        payload: NOTIFICATION_MESSAGES[EMAIL_CHANGE_OTP_RESEND].success
      });
      return response?.data;
    } catch (err) {
      if (err.statusCode === 409) throw err;
      dispatch(handleError(EMAIL_CHANGE_OTP_RESEND, err));
    } finally {
      dispatch({ type: SHOW_LOADING, payload: false });
    }
  };
}
